
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28 56c-.146-.249-3.584-6.128-3.584-8.032a3.586 3.586 0 017.171 0c0 1.9-3.437 7.782-3.584 8.032zm0-13.275a6.16 6.16 0 01-6.183-5.54H14a14.035 14.035 0 013.935-9.891 14.859 14.859 0 01-.218-2.527c0-9.2 2.8-15.446 5.142-19.063A21.326 21.326 0 0128 0a21.814 21.814 0 015.142 5.759c2.346 3.643 5.142 9.918 5.142 19.121a13.218 13.218 0 01-.218 2.394A14.069 14.069 0 0142 37.185h-7.818A6.16 6.16 0 0128 42.725zM28 14.5a4.286 4.286 0 104.333 4.286A4.315 4.315 0 0028 14.5z","fill":"#222"}})])
          )
        }
      }
    